import axios from 'axios';
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from '../router'


var times=1;
const init = function () {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  // Vue.use(ElementUI);
  const vue = new Vue();

  function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return "";
    }
  }


  // 下面的参数有Authorization
  // axios.defaults.headers.common['Authorization'] = "Basic " + getCookie("LoggerToken");
  axios.defaults.headers.common['Authorization'] = "Basic " + localStorage.getItem('LoggerToken');
  // http request 拦截器);
  axios.interceptors.request.use(
    (config) => {
      config.cancelToken = source.token;
      return config;
    },
    (err) => {
      const error = err;
      console.log(err);
      return Promise.reject(error);
    },
  );


  axios.interceptors.response.use(
    (response) => {

      if(response==undefined){
        return response
      }

      let data;
      if (response.data instanceof Object) {

        data = response.data
      } else {

        data = JSON.parse(response.data)
      }
      if(window.location.href.indexOf('login')>-1 ||  window.location.href.indexOf('agree')>-1){
        times=1;
        return response;
      }


      if (data.status == 101 && times==1) {
        times=2;
        // source.cancel('登录过期,已被弹出');
        // if (data.results.url.indexOf('company') > -1) {
        //   location.href = data.results.url;
        // } else {
          vue.$alert('登录验证过期，请重新登录.', '验证过期', {
            showClose: false,
            confirmButtonText:'确定',
            callback: action => {
              router.push({path: '/login', query: {isAllpage:1}});
              // location.href = data.results.url;
            }
          })
          // return new Promise( ( ) =>{})  //处理101返回抛出异常
        // }

      }

      return response
    },
    (error) => {
      if (axios.isCancel(error)) {
        console.log('Request canceled', error.message);

      } else {
        console.log(error.response, 'error.response')
        console.log(error, 'error')
        return Promise.reject(error.response)   // 返回接口返回的错误信息
      }

    })

}

export default {
  init
}



// WEBPACK FOOTER //
// ./src/common/request.js